import {IExtendedSickNote} from '../models/sick-note';
import {EMPTY, Observable} from 'rxjs';
import {ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {SickNoteService} from '../services/sick-note.service';
import {catchError, map} from 'rxjs/operators';
import {SimpleDialogComponent} from '../components/simple-dialog/simple-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {CompanyService} from '../services/company.service';
import {isSessionExpired} from '../models/session-expired-error';

@Injectable({
  providedIn: 'root'
})
export class SickNoteResolverService {
  constructor(public router: Router,
              private sickNoteService: SickNoteService,
              private companyService: CompanyService,
              private dialog: MatDialog) { }

  resolve(routeSnapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot, route: ActivatedRoute):
    Observable<IExtendedSickNote> {

    const shortId = routeSnapshot.paramMap.get('shortId') || routeSnapshot.queryParamMap.get('shortId');

    return this.sickNoteService.getSickNote(shortId).pipe(
      map((sickNote) => {
        if (sickNote) {
          return sickNote;
        }
        throw new Error('Not found');
      }),
      catchError((error) => {
        // The expiry flow is already taking the user to the login. EMPTY cancels
        // this navigation; the dialog would be wrong and the navigate below
        // would race the login redirect.
        if (isSessionExpired(error)) {
          return EMPTY;
        }
        SimpleDialogComponent.open(this.dialog, {
          okButton: 'OK',
          title: 'Documento não encontrado.',
          content: 'Tente novamente ou fale com a gente no botão \"Ajuda\"'
        });
        this.router.navigate(['']);
        return EMPTY;
      })
    );
  }
}
